import Vue from 'vue';
import Router from 'vue-router';
import firebase from "firebase";

Vue.use(Router);

var router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{
      path: '/',
      redirect: '/home',
      component: () => import('@/containers/TopNav'),
      children: [{
        path: 'home',
        name: 'Home',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Dashboard.vue')
      }, {
        path: '/menus',
        name: 'Menus',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Menus.vue')
      }, {
        path: '/orders/:id?',
        name: 'Orders',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Orders.vue')
      }, {
        path: '/orderForm',
        name: 'OrderForm',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/OrderForm.vue')
      }, {
        path: '/promotions',
        name: 'Promotions',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Promotions.vue')
      }, {
        path: '/payments',
        name: 'Payments',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Payments.vue')
      }, {
        path: '/settings',
        name: 'Settings',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Settings.vue')
      }, {
        path: '/push',
        name: 'Push',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Push.vue')
      }, {
        path: '/reportTopMenus',
        name: 'ReportTopMenus',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/ReportTopMenus.vue')
      }, {
        path: '/reportTopCustomers',
        name: 'ReportTopCustomers',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/ReportTopCustomers.vue')
      }, {
        path: '/customers',
        name: 'Customers',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Customers.vue')
      }, {
        path: '/times',
        name: 'Times',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/TimeSetting.vue')
      }, {
        path: '/categories',
        name: 'Categories',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Categories.vue')
      }, {
        path: '/employees',
        name: 'Employees',
        meta: {
          requiresAuth: true
        },
        component: () => import('@/views/pages/Employees.vue')
      }]
    }, {
      path: '/printOrder/:id',
      name: 'PrintOrder',
      meta: {
        requiresAuth: true
      },
      component: () => import('@/views/pages/PrintOrder.vue')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login.vue')
    },
    {
      path: '/404',
      name: 'Page404',
      component: () => import('@/views/Page404.vue')
    },
    {
      path: '/500',
      name: 'Page500',
      component: () => import('@/views/Page500.vue')
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      component: () => import('@/views/Privacypolicy.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser;
  console.log('currentUser', currentUser);
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !currentUser) next('login');
  else if (!requiresAuth && currentUser) next('home');
  else next();
});
export default router;
